import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import {
  Container,
} from './styled';

import { selectWebsiteTheme } from '../../../store/slices/website';

const ItemPlaceholder = ({ itemSize }) => {
  const { colors } = useSelector(selectWebsiteTheme);

  return (
    <Container itemSize={itemSize} bgColor={colors[2].color} />
  );
};

ItemPlaceholder.propTypes = {
  itemSize: PropTypes.shape({
    width: PropTypes.string.isRequired,
    height: PropTypes.string.isRequired,
  }).isRequired,
};

export default ItemPlaceholder;
